/**
 * モーダルを表示する際にデータを管理するファイル
 */

export default {
  namespaced: true,
  state: {
    isDisplay: false,
    bodyName: "",
    title: "",
    picSrc: "",
    galleryModalCurrentIndex: 0
  },
  mutations: {
    changeDisplay(state, value) {
      state.isDisplay = value.state;
      state.bodyName = value.name;

      if (value.name === "picture") {
        state.title = value.caption;
        state.picSrc = value.src;
      }
    },
    setGalleryModalCurrentIndex(state, index) {
      state.galleryModalCurrentIndex = index;
    }
  }
};
